import { Record } from 'immutable';

export const SistemCheck = new Record({
    success: false,
    isPending: false,
    data: {},
    error: null
});